"use client";

import { useContext } from "react";

import { QueueContext } from "../providers/QueueProvider/queueContext";

export const useQueue = () => useContext(QueueContext);
